

function FormCont(props) {
  return (

    <div id="contact">
        <div className="container">
        <h3>Contate-nos</h3>
        <div className="row" data-aos="fade-up" data-aos-delay="300">
            <div className="col-md-12 text-left">
                <p>Deixe aqui sua mensagem com dúvidas ou sugestões:</p>
            </div>
        </div>
          </div>
          <div className="container py-5">
            <div className="row" data-aos="fade-up" data-aos-delay="300">
                <div className="col-md-12">
                    <form>
                        <div className="form-group row">
                            <div className="col-sm-6">
                                <input type="text" className="form-control" placeholder="Nome" required />
                            </div>
                                <div className="col-sm-6">
                                <input type="text" className="form-control" placeholder="Email" required />
                            </div>
                            <div className="col-sm-12">
                                <input type="number" className="form-control" placeholder="Telefone:" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-xs-12 col-md-12">
                                <textarea type="text" className="form-control" placeholder="Mensagem" rows="6" required></textarea>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary">Enviar</button>
                    </form>
                </div>
            </div>
          </div>
      </div>
    
  );
}

export default FormCont;
